<section class="form-manager-placeholder" aria-labelledby="form-manager-heading">
  <h1 id="form-manager-heading">Form Manager</h1>
  <div class="placeholder-body">
    <rds-progress-spinner class="placeholder-spinner"></rds-progress-spinner>
    <p class="placeholder-copy">Form Manager — coming soon with story INEXP-2471</p>
  </div>
  <router-outlet></router-outlet>
</section>
